function LocationSection({ title, subtitle, address, hours, directions, mapUrl }) {
  return (
    <section className="py-10 sm:py-[60px] bg-dark-secondary">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <p className="font-montserrat text-xs tracking-[0.3em] uppercase mb-4" style={{ color: '#b9a1fc' }}>{subtitle}</p>
          <h2 className="font-playfair text-4xl sm:text-5xl font-bold" style={{ color: '#b9a1fc' }}>{title}</h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div className="space-y-8">
            <div>
              <h3 className="font-playfair text-2xl mb-4" style={{ color: '#b9a1fc' }}>Address</h3>
              <p className="font-montserrat text-xl leading-relaxed" style={{ color: '#ddddde' }}>{address}</p>
            </div>
            <div>
              <h3 className="font-playfair text-2xl mb-4" style={{ color: '#b9a1fc' }}>Opening Hours</h3>
              <p className="font-montserrat text-xl" style={{ color: '#ddddde' }}>{hours}</p>
            </div>
            <div>
              <h3 className="font-playfair text-2xl mb-4" style={{ color: '#b9a1fc' }}>How to Get Here</h3>
              <ul className="space-y-3">
                {directions.map((d, i) => (
                  <li key={i} className="flex items-start space-x-3">
                    <span className="mt-1" style={{ color: '#b9a1fc' }}>&#9670;</span>
                    <span className="font-montserrat text-lg" style={{ color: '#ddddde' }}>{d}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <img src="/gallery-exterior.jpg" alt="Bunny Boy Massage Sukhumvit exterior" className="w-full h-64 object-cover" style={{ border: '2px solid #867aae' }} />
            </div>
          </div>

          <div className="w-full h-[400px] lg:h-full min-h-[400px] gold-border">
            <iframe
              src={mapUrl}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Bunny Boy Massage Location"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default LocationSection;
